import {showError} from "helpers/errors";
import * as validation from 'helpers/validation';
import _ from 'lodash';

class Response {
    constructor(response) {
        this.__response = response
    }

    /**
     * @return {Object}
     */
    get data () {
        return this.__response;
    }

    /**
     * @return {Object}
     */
    get payload () {
        return this.data.payload;
    }

    /**
     * @return {Object}
     */
    get headers () {
        return this.data.headers;
    }

    /**
     * @param {string} key
     */
    get(key) {
        return _.get(this.__response, key);
    }

    /**
     * @return {string}
     */
    get status() {
        return 'ok';
    }

    /**
     * @return {boolean}
     */
    get isOk() {
        return true;
    }

    /**
     * @return {boolean}
     */
    get hasErrors() {
        return false;
    }

    showErrors() {}
}

class ErrorResponse extends Response {

    constructor(response) {
        super(response);
    }

    /**
     * @return {boolean}
     */
    get isOk() {
        return false;
    }

    /**
     * @return {string}
     */
    get status() {
        return 'error';
    }

    /**
     * @return {boolean}
     */
    get hasErrors() {
        return true;
    }

    /**
     * @return {Array}
     */
    get errors() {
        return this.__response.errors;
    }

    get validationErrors() {
        return validation.getErrors(this)
    }

    /**
     * @param {string} code
     * @return {boolean}
     */
    hasErrorWithCode(code) {
        return _.filter(this.errors, error => error.code === code).length > 0;
    }

    /**
     * Показать ошибки
     */
    showErrors() {
        showError(this)
    }
}

export const success = data => { return new Response(data); };
export const error = error => { return new ErrorResponse(error); };


export async function makeResponse(callback) {
    try {
        const response = await callback();

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};

// const success = response => ({status: 'ok', data: response});
// const error = error => ({status: 'error', error: error});


// WEBPACK FOOTER //
// ./src/helpers/response.js